var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-before-form"},[_c('h1',[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_c('div',{staticClass:"create-description"},[_vm._v(_vm._s(_vm.$t(_vm.description)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }